export default __webpack_public_path__ + "static/media/genesislogo.3aaa22cc.gif";